<div class="esf-accordion__unit">
  <div class="esf-accordion__trigger -is-open">
    <h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level">
      <span class="esf-action-heading__text" i18n='Section title@@club.heading.address'>Address</span>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">

          <button class="esf-button esf-button--simple"
                  (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditClubAddressModal(true);$event.stopPropagation();"
                  [edsTooltip]="tooltipTranslations.i18nEdit">
            <svg class="esf-icon esf-button__icon" width="16" height="16">
              <use xlink:href="#esf-icon-edit"></use>
            </svg>
            <span class="esf-button__icon-text"></span>
          </button>

        </span>
      </span>
    </h4>
  </div>

  <div class="esf-accordion__target -is-open">

    <div class="esf-info-tile esf-info-tile--full-width">
      <div class="esf-info-tile__content">

        <table class="esf-table" *ngIf="containsData()">
          <thead class="esf-table__head">
            <tr class="esf-table__row">
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.street' data-label="Street">
                <span i18n='Table cell heading@@general.tableCellLabel.street' class="esf-table__cell-inner">Street</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.postCode' data-label="Post code">
                <span i18n='Table cell heading@@general.tableCellLabel.postCode' class="esf-table__cell-inner">Post code</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.city' data-label="City">
                <span i18n='Table cell heading@@general.tableCellLabel.city' class="esf-table__cell-inner">City</span>
              </th>
              <th class="esf-table__cell esf-table__cell--head" i18n-data-label='Table cell heading@@general.tableCellLabel.country' data-label="Country">
                <span i18n='Table cell heading@@general.tableCellLabel.country' class="esf-table__cell-inner">Country</span>
              </th>
            </tr>
          </thead>
          <tbody class="esf-table__body">
            <tr class="esf-table__row">
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.street' data-label="Street">
                <span class="esf-table__cell-inner">{{ selectedClub.street }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.postCode' data-label="Post code">
                <span class="esf-table__cell-inner">{{ selectedClub.postCode }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.city' data-label="City">
                <span class="esf-table__cell-inner">{{ selectedClub.city }}</span>
              </td>
              <td class="esf-table__cell" i18n-data-label='Table cell heading@@general.tableCellLabel.country' data-label="Country">
                <span class="esf-table__cell-inner">{{ getCountry(selectedClub.country) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <table class="esf-table" *ngIf="!containsData()">
          <section class="esf-empty-state flex-empty-state">
            <div>
              <svg class="esf-icon esf-empty-state__icon" width="32" height="32">
                <use xlink:href="#esf-icon-globe"></use>
              </svg>
            </div>
            <p class="esf-paragraph"><small i18n='Text for empty state@@customerOverviewComponent.text.noBankData'>There is no address data</small></p>
          </section>
        </table>

      </div>
    </div>
  </div>
</div>
